export enum ContactTypeEnum {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
    PEC = 'PEC'
}

export enum DocumentStatusEnum {
    NEW = 'New',
    IN_PROGRESS = 'InProgress',
    SIGNED = 'Signed'
}

export enum GatewayEnum {
    EMAIL = 'EMAIL',
    SMS = 'SMS'
}

export enum SignerTypeEnum {
    DOC = 'DOC',
    PAT = 'PAT',
    OTH = 'OTH'
}

export enum SignTypeEnum {
    FES = 'FES',
    FEA = 'FEA',
    PRIVACY = 'PRIVACY'
}

export enum MetadataTypeEnum {
    TEXT = 'TEXT',
    RADIO = 'RADIO',
    CHECKBOX = 'CHECKBOX',
    DROPDOWN = 'DROPDOWN',
}